import React from "react";
import Thermometer from "react-thermometer-component";
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import Decrease from './../images/decrease.svg';
import Increase from './../images/increase.svg';

const styles = {
  dial: {
    display: "inline-block",
    width: `100px`,
    height: `auto`,
    color: "#000",
    border: "0.5px solid #fff",
    padding: "5px"
  },
  title: {
    fontSize: "1em",
    color: "#000",
    marginTop: "15px"
  }
};

function Disabled({ disabled, children }) {
  if (disabled) {
    return (
      <div style={{ opacity: 0.3, pointerEvents: "none" }} disabled>
        {children}
      </div>
    );
  }
  return <React.Fragment>{children}</React.Fragment>;
}

const Temp = ({ id, value, title, desc, trend, disabled }) => {
  return (
    <Disabled disabled={disabled}>
      <Stack direction="column" align="left" spacing={1}>
        <div style={styles.dial}>
          <Thermometer
            theme="light"
            value={value}
            max="100"
            steps="1"
            format="°C"
            size="normal"
            height="160"
          />
        </div>
        <Typography style={{marginTop: 10}} variant="caption" gutterBottom component="div">
          {desc}
        </Typography>
        <Typography variant="subtitle2" gutterBottom component="div">
          {value}°C
        </Typography>
      </Stack>
    </Disabled>
  );
};

export default Temp;
